<script lang="ts">
  import type { GameraTeamReference, GoalEvent } from '@statmuse/core/gamera'
  import ScoringPlay from './scoring-play.svelte'
  import { plays, lineScore, periodClock } from './stores'
  import { max, first } from 'lodash-es'

  export let awayTeam: GameraTeamReference | undefined
  export let homeTeam: GameraTeamReference | undefined
  export let live = false

  $: scoringPlays = $plays.filter(
    (p): p is GoalEvent =>
      p.type === 'goal' &&
      p.period <= max([3, $lineScore.away?.periods?.length]),
  )

  $: currentPlays = $plays.filter((p) => p.period === $periodClock.period)

  $: firstPlayOfCurrentPeriod = first(currentPlays)

  $: hasShootout = firstPlayOfCurrentPeriod?.clock === '00:00'

  $: lastShootoutGoal = hasShootout
    ? currentPlays.findLast((p) => p.type === 'goal')
    : undefined
</script>

{#each scoringPlays as play (play.eventSequence)}
  <ScoringPlay {play} {awayTeam} {homeTeam} />
{/each}

{#if lastShootoutGoal && !live}
  <ScoringPlay play={lastShootoutGoal} {awayTeam} {homeTeam} shootOut />
{/if}
